import { NamedModulesPlugin } from 'webpack';

export default (opts = {}) => (
  new NamedModulesPlugin(opts)
);
